import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Switch } from '../../../components/ui/switch';
import { LoadingSpinner } from '../../../components/layout/SharedComponents';

export function GoodsReceivedSettingsPanel() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [allowOver, setAllowOver] = useState(false);

  useEffect(() => {
    api.get('/api/grn/settings').then(r => {
      setEnabled(r.data.enabled);
      setAllowOver(r.data.allow_over_delivery);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/api/grn/settings', { enabled, allow_over_delivery: allowOver });
      toast.success('GRN settings saved');
    } catch { toast.error('Save failed'); }
    setSaving(false);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-1">Receiving</h1>
      <p className="text-lg font-medium text-muted-foreground mb-6">Receiving Settings</p>

      <div className="space-y-6 max-w-xl">
        <div className="flex items-center justify-between p-4 border rounded-xl">
          <div>
            <p className="font-semibold text-sm">Enable Receiving Module</p>
            <p className="text-xs text-muted-foreground">When enabled, all issued purchase orders can be received through the Receiving process.</p>
          </div>
          <Switch checked={enabled} onCheckedChange={setEnabled} />
        </div>

        {enabled && (
          <div className="flex items-center justify-between p-4 border rounded-xl">
            <div>
              <p className="font-semibold text-sm">Allow Over-Deliveries</p>
              <p className="text-xs text-muted-foreground">
                <strong>No:</strong> The system will not allow receiving more than the ordered quantity.<br/>
                <strong>Yes:</strong> If more items are delivered than ordered, the user can choose to reject the overage or add it to the original order quantity.
              </p>
            </div>
            <Switch checked={allowOver} onCheckedChange={setAllowOver} />
          </div>
        )}

        <div className="flex justify-start">
          <Button onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save Settings'}</Button>
        </div>
      </div>
    </div>
  );
}
